<script>
import ModalLog from "@/components/ModalLog.vue";
import axios from "axios";
import _ from "lodash";
import {TokenMixin} from "@/assets/js/mixins/token-mixin";
import {ErrorsMixin} from "@/assets/js/mixins/errors-mixin";

export default {
  name: "ServerEdit",
  mixins: [
    TokenMixin,
    ErrorsMixin,
  ],
  props: {
    currentItem: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      newIpAddress: '',
      newIpDc: null,
      newIpMask: null,
      newIpGateway: null,
      createIpAction: false,
      DatacenterOptions: [],
      selectHeight: '120px',
      apiIpsList: '/api/manager/ip/list?sort=id&free=y',
      apiTypeList: '/api/manager/server-entities',
      apiUrl: "/api/manager/server/",
      item: {},
      EntityList: [],
      IpList: [],
      textareaData: '',
      error: '',
      loader: null,
    }
  },
  components: {ModalLog},
  methods: {
    loadEntity() {
      axios.get(this.apiTypeList, this.authRespConf())
          .catch((err) => {
            this.loader.hide();
            this.errorHandle(err);
          })
          .then(res => {
            this.loader.hide();
            this.EntityList = _.map(res.data.data, (item, key) => {
              return {
                label: item,
                value: parseInt(key)
              }
            })
          })
    },
    loadDatacenters() {
      axios.post('/api/manager/dc/flat?sort=Ip',
          [],
          this.authRespConf())
          .then(res => {
            if (res.data.data !== undefined) {
              for (let dataIndex in res.data.data) {
                this.DatacenterOptions.push({
                  value: res.data.data[dataIndex]['Id'],
                  label: res.data.data[dataIndex]['Name'],
                });
              }
            }
          });
    },
    loadServer() {
      axios.get(`${this.apiUrl}/${this.currentItem.Id}`, this.authRespConf())
          .catch((err) => {
            this.loader.hide();
            this.errorHandle(err);
          })
          .then(res => {
            this.loader.hide();
            this.item = res.data.data
          })
    },
    loadIps() {
      axios.post(this.apiIpsList, [], this.authRespConf())
          .catch((err) => {
            this.loader.hide();
            this.errorHandle(err);
          })
          .then(res => {
            this.loader.hide();
            this.IpList = _.map(res.data.data, (item) => {
              return {
                label: item.Address,
                value: item.Id
              }
            })

            this.IpList.push({label: this.currentItem.Ip, value: this.currentItem.IpId})
          })
    },
    modalOpened() {
      this.loader = this.$loading.show()
      this.loadEntity()
      this.loadIps()
      this.loadServer()
      this.selectHeight = this.$refs.modalBox.clientHeight + 'px;'
    },
    closeModal() {
      this.item = {}
      this.loaded = false
      this.$modal.hide('ServerEdit')
    },
    submitForm() {
      let loader = this.$loading.show();
      this.error = '';
      axios.patch(this.apiUrl, this.item, this.authRespConf())
          .then(res => {
            loader.hide();
            if (res !== null && res !== undefined) {
              if (res.data.message !== null && res.data.message !== undefined) {
                this.$bvToast.toast(res.data.message, {
                  title: 'Error',
                  autoHideDelay: 5000,
                  variant: 'danger',
                  appendToast: true
                })
                return
              }
            }
            this.$bvToast.toast('', {
              title: 'Server added successfully',
              autoHideDelay: 5000,
              variant: 'success',
              appendToast: true
            })
            this.closeModal()
          })
          .catch((err) => {
            loader.hide();
            this.errorHandle(err, true, true, `Server: ${this.item.Name} error`);
          });
    },
    checkAndCreateIp(ip) {
      // Регулярное выражение для проверки IP-адреса в формате "xxx.xxx.xxx.xxx"
      const ipRegex = /^(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))\.(\d|[1-9]\d|1\d\d|2([0-4]\d|5[0-5]))$/;
      if (ipRegex.test(ip)) {
        return true;
      } else {
        this.$bvToast.toast('Invalid IP format', {
          title: 'Error',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        return false;
      }
    },
    createIp(newIp) {
      if (this.checkAndCreateIp(newIp.value)) {
        this.newIpAddress = newIp.value
        this.formData.IpId.value = null
      }
    },
    addNewIp(event) {
      if (event === null || this.newIpAddress.length <= 1) return;
      const payload = {
        Address: this.newIpAddress,
        DcId: this.newIpDc,
        Gateway: this.newIpGateway,
        Mask: this.newIpMask,
      }
      axios.post('api/manager/ip/', payload, this.authRespConf())
          .catch((err) => {
            this.errorHandle(err, true, true, 'Add IP Error');
            this.closeSelectDatacenterForNewIp()
          })
          .then(res => {
            if (res !== undefined) {
              this.$bvToast.toast('', {
                title: 'IP added successfully',
                autoHideDelay: 5000,
                variant: 'success',
                appendToast: true
              })
              this.IpList.push({
                value: res.data.Id,
                label: res.data.Address
              })
              this.item.IpId = res.data.Id
              this.$modal.hide('selectDatacenterForNewIp')
            }
          })
    },
    closeSelectDatacenterForNewIp() {
      this.$modal.hide('selectDatacenterForNewIp')
      this.newIpDc = null
      this.newIpMask = null
      this.newIpGateway = null
      this.newIpAddress = null
      this.item.IpId = null
    },

  },
  watch: {
    newIpAddress(val) {
      if (val) {
        this.$modal.show('selectDatacenterForNewIp')
      }
    }
  },
  computed: {
    IpIdValue: {
      get: function () {
        return this.item.IpId
      },
      set: function (newValue) {
        // const isValuePresent = _.some(this.formData.IpId.options, { value: newValue });
        // if (isValuePresent) {
        this.item.IpId = newValue
        // }
      }
    }
  }
}
</script>

<template>
  <modal
      :draggable="true"
      :resizable="true"
      :clickToClose="false"
      name='ServerEdit'
      :min-width="425"
      :width="850"
      :min-height="(500 / 2)"
      :height="620"
      :scrollable="true"
      @opened="modalOpened"
      class="modalBox"
      :style="{'--selectHeight': selectHeight}"
  >
    <modal
        :draggable="true"
        :resizable="true"
        :clickToClose="false"
        name='selectDatacenterForNewIp'
        :min-width="425"
        :width="550"
        :min-height="(450 / 2)"
        :height="450"
        :scrollable="true"
        @opened="loadDatacenters"
        class="modalBox"
        :style="{'--selectHeight': selectHeight}"
    >
      <div class="window-header">
        Select Datacenter for IP: {{ newIpAddress }}
        <a href="javascript:void(0)" class="close-modal pull-right" @click="closeSelectDatacenterForNewIp">
          <i class="fa fa-times"></i>
        </a>
      </div>
      <div class="modal-body">
        <form ref="form" class="form-horizontal" @submit.prevent="addNewIp">
          <div class="row">
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="type">Gateway</label>
              <input
                  type="text"
                  class="form-control"
                  placeholder="N/A"
                  required
                  name="name"
                  v-model="newIpGateway">
            </div>
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="type">Mask</label>
              <input
                  type="text"
                  class="form-control"
                  placeholder="N/A"
                  required
                  name="name"
                  v-model="newIpMask">
            </div>
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="type">Datacenter for new IP</label>
              <v-select required :options="DatacenterOptions" :reduce="dc => dc.value" v-model="newIpDc"
                        placeholder="Datacenter"
                        inputId="dcName"/>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 mt-2"><p class="text-danger">* Required fields</p></div>
            <div class="col-sm-8 mt-2" style="text-align:right">
              <button type="button" @click="closeSelectDatacenterForNewIp" class="btn btn-danger text-white mr-2">
                Cancel
              </button>
              <button type="submit" class="btn btn-primary">Create</button>
            </div>
          </div>
        </form>
      </div>
    </modal>
    <div class="window-header">
      Edit Server: {{ item.Name }}
      <a href="javascript:void(0)" class="close-modal pull-right" @click="closeModal">
        <i class="fa fa-times"></i>
      </a>
    </div>
    <div class="modal-body" ref="modalBox">
      <div class="page-modal" style="background:white">
        <div class="alert alert-danger alert-dismissable" v-show="error !== ''">
          <strong>Error </strong>
          <div class="errorMsg" style="display: inline-block;">{{ error }}</div>
        </div>
        <form ref="form" class="form-horizontal" @submit.prevent="submitForm">
          <div class="row">
            <div class="col-sm-12">
              <label class="col-form-label" for="name">Id</label>
              <input
                  type="text"
                  class="form-control"
                  disabled
                  name="name"
                  :value="item.Id">
            </div>
            <div class="col-sm-12">
              <label class="col-form-label" for="name">Name <span class="text-danger">*</span></label>
              <input
                  type="text"
                  class="form-control"
                  placeholder="N/A"
                  required
                  name="name"
                  v-model="item.Name">
            </div>
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="type">Type <span class="text-danger">*</span></label>
              <v-select :options="EntityList"
                        :reduce="entity => entity.value"
                        v-model="item.Entity"
                        clearable
                        required
                        maxHeight="50px"
                        placeholder="N/A"
                        name="type"
                        inputId="valueType"/>
            </div>
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="ip">Ip <span class="text-danger">*</span></label>
              <v-select :options="IpList"
                        :reduce="ip => ip.value"
                        :create-option="ip => ({ label: ip, value:ip  })"
                        taggable
                        required
                        @option:created="createIp"
                        v-model="IpIdValue"
                        clearable
                        maxHeight="50px"
                        placeholder="N/A"
                        name="ip"
                        ref="ipIdSelect"
                        inputId="valueIp"/>
            </div>
            <div class="col-sm-12 mt-1">
              <label class="col-form-label" for="real_name">Comment</label>
              <input
                  type="text"
                  class="form-control"
                  placeholder="N/A"
                  name="real_name"
                  v-model="item.RealName">
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4 mt-2"><p class="text-danger">* Required fields</p></div>
            <div class="col-sm-8 mt-2" style="text-align:right">
              <button type="button" @click="closeModal" class="btn btn-danger text-white mr-2">Cancel
              </button>
              <button type="submit" class="btn btn-primary">Update</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <ModalLog :data="textareaData" :modalName="'itemTextarea'" @close="closeModal"/>
  </modal>
</template>
